<template>
  <div :class="['tm-ellipsis', { 'tm-ellipsis--expand': expand, 'tm-ellipsis--reduce-padding': reducePadding }]">
    <div :class="[`tm-ellipsis__in`, { 'tm-ellipsis__align-html': alignHtml }]">
      <span class="tm-ellipsis__content">
        <slot />
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
const { minWidth = '200px' } = defineProps<{
  minWidth?: string
  expand?: boolean
  alignHtml?: boolean
  reducePadding?: boolean
}>()
</script>

<style lang="scss" scoped>
.tm-ellipsis {
  position: relative;
  line-height: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  overflow: hidden;
  &:before {
    content: '&nbsp;';
    visibility: hidden;
    min-width: v-bind(minWidth);
    display: block;
  }
  &--reduce-padding {
    padding-top: 0;
    padding-bottom: 0;
  }
  &--expand {
    &:before {
      display: none;
    }

    .tm-ellipsis__in {
      position: relative;
    }

    .tm-ellipsis__content {
      white-space: normal;
    }
  }
  &__in {
    position: absolute;
    inset: 0;
    display: flex;
    flex-flow: column;
    justify-content: center;
    margin: -4px;
    padding: 4px;
    overflow: hidden;
  }
  &__content {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
  }
  &__align-html {
    flex-flow: row;
    justify-content: start;
    align-items: center;
  }
}
</style>
